var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10854IconServiceMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b122302a-f09e-4194-83f1-be587a2d78bd",
    x1: -655.236,
    y1: 2848.852,
    x2: -637.632,
    y2: 2879.398,
    gradientTransform: "matrix(0.5, 0.866, 0.866, -0.5, -2152.371, 1995.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#004e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0826712-a32a-4db2-8ce4-ce349db35558",
    x1: -4132.03,
    y1: -451.06,
    x2: -4110.646,
    y2: -413.559,
    gradientTransform: "matrix(-0.5, -0.866, -0.866, 0.5, -2426.789, -3338.209)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#004685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfb250ff-0c6e-4198-b82c-2afbc5fd923a",
    x1: 5.986,
    y1: 506.861,
    x2: 7.43,
    y2: 515.104,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 521.307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#99edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#b0efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#bef1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3f1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b4bf3201-4e06-4d9e-8474-3654b7929c12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.226,3.927,13.6,6.442l3.048-1.76A8.79,8.79,0,0,0,2.718,2.824,10.022,10.022,0,0,1,9.226,3.927Z",
    fill: "url(#b122302a-f09e-4194-83f1-be587a2d78bd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.541,6.442l-.069,6.034,3.168.851A8.793,8.793,0,0,0,11.4.536,10.454,10.454,0,0,1,13.541,6.442Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.535,11.646l-4.552,2.63.071,3.5a8.8,8.8,0,0,0,8.764-8.8,8.48,8.48,0,0,0-.288-2.09A9.579,9.579,0,0,1,13.535,11.646Z",
    fill: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.983,14.276l-4.555-2.63-3.02,1.812A8.782,8.782,0,0,0,15.08,15.339,9.907,9.907,0,0,1,8.983,14.276Z",
    fill: "url(#a0826712-a32a-4db2-8ce4-ce349db35558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.425,11.646l.069-6.237L1.377,4.588A8.727,8.727,0,0,0,.183,9a8.846,8.846,0,0,0,6.535,8.5A10.184,10.184,0,0,1,4.425,11.646Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.583,6.3l4.4-2.543A10.573,10.573,0,0,0,3.041,2.512,8.754,8.754,0,0,0,.183,9,8.966,8.966,0,0,0,.5,11.32,10.245,10.245,0,0,1,4.583,6.3Z",
    fill: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "13.535 11.646 13.535 6.386 8.98 3.757 4.425 6.386 4.425 11.646 8.98 14.276 13.535 11.646",
    fill: "#c3f1ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.986 9.071 8.986 14.276 4.425 11.646 4.425 6.404 8.986 9.071",
    fill: "url(#bfb250ff-0c6e-4198-b82c-2afbc5fd923a)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.98 9.071 8.98 14.276 13.541 11.646 13.541 6.404 8.98 9.071",
    fill: "#50e6ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10854IconServiceMedia);
export default __webpack_public_path__ + "static/media/10854-icon-service-Media.d45487e577c7964e990ea04d2243e013.svg";
export { ForwardRef as ReactComponent };